/**
 * Аутентификация (CASE-49). Вход — cookie-сессия самого приложения; PWA
 * после успешного login получает httpOnly-cookie и дальше ходит по ней.
 */
import { apiGet, apiPost } from '../client.js';

export interface Me {
  /** Логин текущего пользователя (user1/user2/user3). */
  readonly login: string;
}

/** Текущий пользователь. Бросает ApiError 401, если вход не выполнен. */
export async function me(): Promise<Me> {
  return apiGet<Me>('/api/v1/auth/me');
}

/** Вход: логин + 7-значный пароль. Бросает ApiError 401 при неверной паре. */
export async function login(loginName: string, password: string): Promise<Me> {
  return apiPost<Me, { login: string; password: string }>('/api/v1/auth/login', {
    login: loginName,
    password,
  });
}

/** Выход — гасит cookie-сессию. */
export async function logout(): Promise<void> {
  await apiPost('/api/v1/auth/logout');
}
